import React from "react"

const TabRecommended = ({ recommendedUseData,category }) => {

  if(category === "Slabs"){
    return (
      <>
        <div className="col-text">
        {recommendedUseData &&
          recommendedUseData.description.length > 0 &&
          recommendedUseData?.description.map((item, index) => (
            <p className="tabWrapper-list-type">
              {item}
            </p>
          ))}
        </div>
      </>
    )
  }

  return (
    <>
      <ul>
        {recommendedUseData &&
          recommendedUseData.description.length > 0 &&
          recommendedUseData?.description.map((item, index) => (
            <li className="tabWrapper-list-type" key={`recommended-${index}`}>
              {item}
            </li>
          ))}
      </ul>
    </>
  )
}

export default TabRecommended
